var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_500_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 1.74997C10.5699 1.59676 10.7518 1.47523 10.952 1.39232C11.1521 1.3094 11.3667 1.26672 11.5834 1.26672C11.8 1.26672 12.0146 1.3094 12.2147 1.39232C12.4149 1.47523 12.5968 1.59676 12.75 1.74997C12.9032 1.90318 13.0248 2.08507 13.1077 2.28524C13.1906 2.48542 13.2333 2.69997 13.2333 2.91664C13.2333 3.13331 13.1906 3.34786 13.1077 3.54804C13.0248 3.74821 12.9032 3.9301 12.75 4.08331L4.87502 11.9583L1.66669 12.8333L2.54169 9.62497L10.4167 1.74997Z",
    stroke: "#2D3280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_500_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.fa712eb417969115b8df56797585cf19.svg";
export { ForwardRef as ReactComponent };